// Vue + Router
import Vue from 'vue'
import VueRouter from 'vue-router'

// Views
import Home from '../views/Home.vue'
import Chauffage from '../views/Chauffage.vue'
import Decoration from '../views/Decoration.vue'
import Sanitaire from '../views/Sanitaire.vue'
import Contact from '../views/Contact.vue'
import Merci from '../views/Merci.vue'
import Mentions from '../views/Mentions.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Accueil',
    component: Home,
    meta: {
      title: 'Happy Chauffe - Accueil'
    }
  },
  {
    path: '/chauffage',
    name: 'Chauffage',
    component: Chauffage,
    meta: {
      title: 'Happy Chauffe - Chauffage'
    }
  },
  {
    path: '/decoration',
    name: 'Peinture et décoration',
    component: Decoration,
    meta: {
      title: 'Happy Chauffe - Peinture et décoration'
    }
  },
  {
    path: '/sanitaire',
    name: 'Salle de bain et sanitaire',
    component: Sanitaire,
    meta: {
      title: 'Happy Chauffe - Salle de bain et sanitaire'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'Happy Chauffe - Formulaire de contact'
    }
  },
  {
    path: '/merci',
    name: 'Merci',
    component: Merci,
    meta: {
      title: 'Happy Chauffe - Merci !'
    }
  },
  {
    path: '/mentions-legales',
    name: 'Mentions légales',
    component: Mentions,
    meta: {
      title: 'Happy Chauffe - Mentions légales'
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash',
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router
